import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  progressBar: {
    background: "#F2F4F7",
    borderRadius: "8px",
    overflow: "hidden",
    height: "35px",
    position: "relative",
    width: "100%",
  },
  text: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 12,
    lineHeight: "24px",
    color: "#FFFFFF",
  },
  progress: {
    height: "100%",
    background: "#32D583",
    opacity: "1 !important",
    width: (props: { value: number | string }) => (props?.value ? `${props?.value}%` : `0%`),
  },
  wrapperSummary: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    top: "50%",
    transform: "translateY(-50%)",
    left: "13px",
    position: "absolute",
    width: "calc(100% - 32px)",
  },
  summary: {
    font: "600 14px/21px Manrope",
    color: "#101828",
  },
}));

export default styles;
